/**
 * Tiny Web Audio beeps — no assets. Unlock on first gesture.
 */
let ctx: AudioContext | null = null;

function ac(): AudioContext | null {
  try {
    if (!ctx) ctx = new AudioContext();
    if (ctx.state === "suspended") void ctx.resume();
    return ctx;
  } catch {
    return null;
  }
}

export function unlockAudio() {
  ac();
}

function beep(opts: {
  freq: number;
  dur: number;
  type?: OscillatorType;
  gain?: number;
  slide?: number;
}) {
  const c = ac();
  if (!c) return;
  const t0 = c.currentTime;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = opts.type ?? "square";
  osc.frequency.setValueAtTime(opts.freq, t0);
  if (opts.slide) osc.frequency.exponentialRampToValueAtTime(Math.max(40, opts.slide), t0 + opts.dur);
  const vol = opts.gain ?? 0.08;
  g.gain.setValueAtTime(vol, t0);
  g.gain.exponentialRampToValueAtTime(0.001, t0 + opts.dur);
  osc.connect(g);
  g.connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + opts.dur + 0.02);
}

export const sfx = {
  place() {
    beep({ freq: 520, dur: 0.07, type: "triangle", gain: 0.09 });
    beep({ freq: 780, dur: 0.05, type: "square", gain: 0.04 });
  },
  miss() {
    beep({ freq: 180, dur: 0.18, type: "sawtooth", gain: 0.06, slide: 70 });
  },
  win() {
    beep({ freq: 440, dur: 0.12, type: "triangle", gain: 0.08 });
    window.setTimeout(() => beep({ freq: 554, dur: 0.12, type: "triangle", gain: 0.08 }), 90);
    window.setTimeout(() => beep({ freq: 659, dur: 0.22, type: "triangle", gain: 0.09 }), 180);
  },
  start() {
    beep({ freq: 330, dur: 0.08, type: "square", gain: 0.05 });
    beep({ freq: 660, dur: 0.12, type: "triangle", gain: 0.06 });
  },
  ui() {
    beep({ freq: 880, dur: 0.04, type: "square", gain: 0.04 });
  },
};
